import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
const badges = ['6 Professional Playbooks', '5 Bonuses', '30+ Clinical Tools'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-950 px-4 pb-14 pt-10 sm:px-6 sm:pb-20 sm:pt-14" data-id="element-203" data-mp="cvbczd7t2zlr">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-[radial-gradient(ellipse_at_top,rgba(201,162,75,0.16),transparent_65%)]" aria-hidden="true" data-id="element-204" data-mp="hvz3lxs4hefg" />
      <div className="relative mx-auto flex w-full max-w-5xl flex-col items-center text-center" data-id="element-205" data-mp="quu9t9v62oir">
        <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-gold-500 sm:text-xs" data-id="element-206" data-mp="vm2mcersmq05">
          Created by Dr. Karito
        </p>

        <h1 className="mt-4 font-display text-[30px] font-bold uppercase leading-[1.08] text-white sm:text-5xl lg:text-6xl" data-id="element-207" data-mp="10knpon2cdpst">
          Oclusion
          <span className="mt-1 block text-gold-500" data-id="element-208" data-mp="1aj3fmmpmut0q">Clinical Playbook™</span>
        </h1>

        <p className="mt-4 max-w-2xl text-[13px] font-semibold uppercase tracking-[0.14em] text-slate-300 sm:text-base" data-id="element-209" data-mp="9njb4dqh2id9">
          The clinical decision system for complex rehabilitation cases
        </p>

        <div className="gold-rule mt-6 h-px w-40" data-id="element-210" data-mp="3vuhip6a3vdt1" />

        <p className="mt-6 max-w-2xl font-display text-xl font-bold leading-snug text-white sm:text-3xl" data-id="element-211" data-mp="3vvaoo518pza4">
          Stop second-guessing your next clinical decision.
        </p>

        <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-slate-300 sm:text-lg" data-id="element-212" data-mp="sczd75ht2ivs">
          A practical clinical playbook created by Dr. Karito to help dentists organize complex
          cases, identify critical clinical signals, and structure their decision-making around
          occlusion, vertical dimension and rehabilitation planning.
        </p>

        <img src="https://cdn.magicpatterns.com/uploads/fok5aApCxj9WMmmmYGa4u4/OCLUSION-EN.png" alt="The complete Oclusion Clinical Playbook collection: six playbooks, clinical checklists, decision maps and digital quick references" className="mt-8 w-full max-w-2xl" width={1080} height={1080} data-id="element-213" data-mp="1b5bowiucmwil" />

        <ul className="mt-6 flex w-full flex-col gap-2 sm:flex-row sm:justify-center sm:gap-3" data-id="element-214" data-mp="35n38adcbu88v">
          {badges.map(badge => <li key={badge} className="flex items-center justify-center gap-2 rounded-lg border border-gold-500/25 bg-navy-900 px-3 py-2.5 text-[13px] font-bold uppercase tracking-wide text-gold-400 sm:text-sm" data-id="element-215" data-mp="2vuxjtdlaa8yf">
              <CheckIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-216" data-mp="2mvty01uqffg8" />
              {badge}
            </li>)}
        </ul>

        <div className="mt-8 w-full" data-id="element-217" data-mp="2cw33i06690g5">
          <CtaButton id="primary-cta" label="Get the Oclusion Clinical Playbook™" subLabel="Instant access · One-time payment · Lifetime access · 7-day guarantee" data-id="element-218" data-mp="2cx4fc6v0hqyx" />
        </div>
      </div>
    </header>;
}